/** The `feature` attribute on every Start Strong after-SAP New Relic event and Sentry report. */
export const START_STRONG_FEATURE = 'start_strong_after_sap';

/** How long the plan has to be ready, measured from page open, before a visit counts as `deadline_exceeded`. */
export const PLAN_READY_DEADLINE_MS = 20_000;
